import React from 'react';
import { Dialog, DialogActions, DialogContent, Button, TextField, Switch, Fab, Grid } from '@material-ui/core'
import SpecificComponent from '../SpecificComponent';





export default class AlertIntarziereTask extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {

    }


    render() {
        return (
            <div>
                <Dialog
                    className="pm-alert-dialog"
                    disableEscapeKeyDown
                    open={this.props.open}
                    onClose={this.props.dialogClose}
                    style={{ zIndex: 6000 }}
                    
                >
                    <DialogActions >
                        <Fab onClick={this.props.dialogClose} className="pm-round-button-dialog">
                            <i className='material-icons pm-round-button-text=dialog'>close</i>
                        </Fab>
                    </DialogActions>
                    <h2 className='pm-dialog-alert-title'>{this.dictionary.proiecte.taskDelay}</h2>


                    <DialogContent>
                        <Grid style={{minWidth:300}} container>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <input
                                    style={{ width: '90%', marginLeft: 10 }}
                                    className='add-project-input'
                                    type="text"
                                    margin="normal"
                                    name='nume'
                                    placeholder={this.dictionary.proiecte.taskDelayHere}
                                    value={this.props.motivIntarziere || ''}

                                    onChange={this.props.changeMotiv}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions className="pm-dialog-bottom-buttons">


                        <Button disabled={this.props.motivIntarziere.length < 3}  
                                        style={{ backgroundColor:this.props.motivIntarziere.length >= 3 ? 'rgb(24 165 58 )' : 'gray', color: this.props.motivIntarziere.length >= 3 ? 'white' : 'black', textTransform: 'unset', paddingLeft: 40, paddingRight: 40}}
                                        variant="contained"
                                        color="primary"onClick={this.props.updateTask} >
                            {this.dictionary.proiecte.finalize}
                          </Button>

                    </DialogActions>


                </Dialog>
            </div>
        );
    }
}